export const verticals = [
  'Arts/Culture',
  'Health/Fitness',
  'Cars/Automotive/Vehicles',
  'Lifestyle',
  'Beauty/Makeup',
  'Nature/Environment',
  'Business/Finance',
  'News and Events',
  'Personal Diary',
  'Entertainment/Showbiz',
  'Pets/Animals',
  'Family/Relationships',
  'Photography/Photo Blog',
  'Fashion/Style',
  'Politics/Society',
  'Food/Dining',
  'Sports/Recreational Activities',
  'Fictional Character/CGI',
  'Tech/Electronics/Gadgets',
  'Gaming/eSports',
  'Travel/Adventures',
  'Music/Dance',
  'Agriculture/Plants',
  'Cosplay',
  'Education'
].sort((a, b) => a.localeCompare(b))
